import React, { useState } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { STATE_STATUS } from '@awp/constants';

import PropTypes from 'prop-types';

const ConfirmModal = ({ isOpen, toggleModal, cfmConfig, actionState, actionStateMessage }) => {
  const closeModal = () => {
    if (isOpen) toggleModal();
  };

  return (
    <Modal
      show={isOpen}
      onHide={toggleModal}
      backdrop="static"
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title style={{ width: '100%' }}>{cfmConfig.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {actionState == STATE_STATUS.FAILED ? (
          <div className="d-flex text-danger">
            <p>{actionStateMessage}</p>
          </div>
        ) : (
          <div className="d-flex">
            <p>{cfmConfig.message}</p>
          </div>
        )}
      </Modal.Body>
      {actionState == '' ? (
        <Modal.Footer>
          <Button variant="primary" onClick={cfmConfig.cfmAction}>
            {cfmConfig.cfmBtnText}
          </Button>
          <Button variant="secondary" onClick={closeModal}>
            {cfmConfig.cancelBtnText}
          </Button>
        </Modal.Footer>
      ) : actionState == STATE_STATUS.LOADING ? (
        <Modal.Footer>
          <Button variant="primary" disabled>
            <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />
            {actionStateMessage}...
          </Button>
        </Modal.Footer>
      ) : (
        <Modal.Footer>
          <Button variant="primary" onClick={closeModal}>
            Close
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};

ConfirmModal.propTypes = {
  isOpen: PropTypes.bool,
  toggleModal: PropTypes.func,
  cfmConfig: PropTypes.object,
  actionState: PropTypes.string,
  actionStateMessage: PropTypes.string,
};

export default ConfirmModal;
